export type AcknowledgementOwner = {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
};

/** Undo submits every grouped ID, so the control is only offered when the reviewer can undo all of them. */
export const getGroupedAcknowledgementState = ({
  owners,
  currentUserId,
  isPrivileged,
  acknowledgedByCurrentUser,
}: {
  owners: Array<AcknowledgementOwner | null | undefined>;
  currentUserId: string | undefined;
  isPrivileged: boolean;
  acknowledgedByCurrentUser: boolean;
}) => {
  const presentOwners = owners.filter((owner): owner is AcknowledgementOwner => Boolean(owner));
  const hasMissingOwner = presentOwners.length !== owners.length;
  const uniqueOwnerIds = [...new Set(presentOwners.map((owner) => owner.id))];
  const mixedOwners = uniqueOwnerIds.length > 1 || (hasMissingOwner && presentOwners.length > 0);
  const allOwnedByCurrentUser =
    acknowledgedByCurrentUser ||
    (!hasMissingOwner &&
      presentOwners.length > 0 &&
      uniqueOwnerIds.length === 1 &&
      uniqueOwnerIds[0] === currentUserId);

  return {
    canUndo: isPrivileged || allOwnedByCurrentUser,
    byYou: allOwnedByCurrentUser,
    mixedOwners,
    otherOwner:
      !allOwnedByCurrentUser && !hasMissingOwner && uniqueOwnerIds.length === 1
        ? presentOwners[0]
        : undefined,
  };
};
